import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { urlApi } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import Bg from '../Medias/Photos/photo-bg7.jpg';
import lighthouse from '../Medias/Photos/logo-lighthouse.png';
import infoquest from '../Medias/Photos/logo-dataxet-infoquest.png';
import tcca from '../Medias/Photos/TCCA-LOGO.jpg';

const Network = ({ contents }) => {
  console.log(contents)

  return (
    <>
      <SectionHeader topic='Our Network & Partners' detail='We collaborate with a broad legal network, ensuring seamless support across jurisdictions and legal fields.' bg={Bg} />
      <section className='mt-5 mb-5 pt-5 pb-5'>
        <Container className='text-center'>
          <Row>
            <Col xs={12} md={4} className='mx-auto'>
              <a href='https://www.lighthouse-asia.com/' target='_blank' className='text-decoration-none tx-color-secondary'>
                <img src={lighthouse} style={{ maxWidth: '320px' }} />
                <h6 className='mt-4 mb-2 fw-bold'>Lighthouse Asia</h6>
              </a>
              <p>Lighthouse Asia Consulting is a boutique advisory firm specializing in project development for energy and infrastructure initiatives within the ASEAN region. PTA has collaborated closely with Lighthouse Asia to integrate legal, technical, and financial expertise, delivering commercially oriented solutions for our clients’ energy projects.</p>
            </Col>
            {/* <Col xs={12} md={4} className='mx-auto'>
              <a href='https://www.dataxet.co/' target='_blank' className='text-decoration-none tx-color-secondary'>
                <h5 className='font-header'>Media Partner</h5>
                <img src={infoquest} style={{ maxWidth: '320px' }} />
                <h6 className='mt-4 mb-2 fw-bold'>InfoQuest News Agency (Dataxet Limited)</h6>
              </a>
              <p>InfoQuest News Agency (Dataxet Limited) is a leading media intelligence company and news agency in Thailand that has been working for more than two decades alongside major players in the country’s media industry. Shaping major business and investment decisions, InfoQuest has been reporting in real-time stories on the stock market, finance, economy, investments, and world news. InfoQuest now dedicated a segment called “Power of the Act” authored by Dr. Piti Eiamchamroonalrp where he regularly (twice a month) publishes articles containing legal analyses on emerging trends, businesses, and investments in the energy sector.</p>
            </Col>
            <Col xs={12} md={4} className='mx-auto'>
              <span className='text-decoration-none tx-color-secondary'>
                <img src={tcca} style={{ maxWidth: '320px' }} />
                <h6 className='mt-4 mb-2 fw-bold'>TCCA</h6>
              </span>
              <p>TCCA functions as a central platform for uniting knowledge, technology, and collaboration across the public sector, private sector, academic institutions, and civil society. Its primary focus is on developing infrastructure and policies that support the adoption of CCUS technology. Our company was officially invited by TCCA (Letter No. Or. Ror. 6005/822, dated September 19, 2025) to become a member of this alliance. We have actively contributed to TCCA by providing legal analysis and innovative legal solutions to facilitate the practical implementation of CCUS projects in Thailand.</p>
            </Col> */}
          </Row>
        </Container>
      </section>
    </>
  )
}

Network.defaultProps = {
  contents: {
    lang: 'th',
    content: {
      contents: []
    }
  },
  web_setup: {
    practice_topic: [],
    practice: []
  },
  path: '',
  lang: 'en'
}

export default Network